// extracted by mini-css-extract-plugin
module.exports = {"take-space":"CloseBar_take-space__YX7jf","top-right":"CloseBar_top-right__3LobF"};